import { render } from "./News.vue?vue&type=template&id=57a48314&scoped=true"
import script from "./News.vue?vue&type=script&lang=js"
export * from "./News.vue?vue&type=script&lang=js"

import "./News.vue?vue&type=style&index=0&id=57a48314&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-57a48314"

export default script